import React from 'react'
import { storyCardData } from '../../data/storyData'
import { StoryCardProps } from '../../interfaces/interfaces.d'
import { StoryCard } from '../cards/storyCard/StoryCard'
import { WrapperMainFour } from './Main.styles'



export const MainSectionFour = () => {

  return (
    <>
         <WrapperMainFour>
    
            {
                storyCardData.map((data: StoryCardProps, index: number)=>(
                           <StoryCard
                                key={index}
                                title ={data.title}
                                text={data.text}
                            />
                        //     <StoryCardWrapper key={index}>
                        //     <div>
                        //             <h1>
                        //                 {data.title}
                        //             </h1>
                        //             <BodyText>
                        //                 {data.text}
                        //             </BodyText>
                        //     </div>
                        // </StoryCardWrapper>
                 
                ))
            }
            
        </WrapperMainFour>

    </>
  )
}